import * as ng from 'angular';
import ITranslateService = angular.translate.ITranslateService;
import IScope = angular.IScope;
import IDirective = angular.IDirective;
import IDirectiveFactory = angular.IDirectiveFactory;
import IAttributes = angular.IAttributes;
import IHttpService = angular.IHttpService;
import INgModelController = angular.INgModelController;

let template = require('./dv-date-range.html');

/* TODO: Copied from https://plnkr.co/edit/Idbc1JNHKylHuX6mNwZ6?p=info to filter dateRange in Anlaufstelle. Is is not working at the moment and will
 /* be fixed in FS-183
 */
export class DvDateRange implements IDirective {
    restrict = 'E';
    require: any = {ngModelCtrl: '^stTable'};
    scope = {
        before: '=',
        after: '='
    };
    controller = DvDateRangeController;
    controllerAs = 'vm';
    bindToController = true;
    template = template;

    link = (scope: any, element: any, attributes: any, controller: DvDateRangeController) => {
        let inputs = element.find('input');
        let inputBefore = ng.element(inputs[0]);
        let inputAfter = ng.element(inputs[1]);
        let predicateName = attributes.predicate;

        [inputBefore, inputAfter].forEach(function (input) {

            input.bind('blur', function () {

                let query: any = {};

                if (scope.before) {
                    query.before = scope.before;
                }

                if (scope.after) {
                    query.after = scope.after;
                }

                scope.$apply(function () {
                    controller.ngModelCtrl.search(query, predicateName);
                });
            });
        });

    };

    static factory(): IDirectiveFactory {
        const directive = () => new DvDateRange();
        directive.$inject = [];
        return directive;
    }
}

export class DvDateRangeController {
    static $inject: string[] = ['$http'];

    ngModelCtrl: any;

    /* @ngInject */
    constructor(private $http: IHttpService) {

    }
}




// WEBPACK FOOTER //
// ./src/app/core/directive/dv-date-range/dv-date-range.ts